<template>
  <div
    id="app"
    :class="{'home-background': isHomeRoute }"
  >
    <md-app md-mode="fixed">
      <md-app-toolbar
        class="md-nav-color"
      >
        <div
          v-if="hideMenu"
          class="menu-position"
        >
          <md-button
            class="md-icon-button"
            @click="menuVisible = !menuVisible"
          >
            <md-icon>menu</md-icon>
          </md-button>
          <div class="md-layout md-alignment-center-right"> 
            <img
              alt="kab logo"
              width="89"
              height="61"
              :src="require('../assets/bn-w@2x.png')"
              @click="goToWelcome"
            >
          </div>
        </div>
        <div
          v-else
          class="menu-items"
        >
          <img
            alt="kab logo"
            width="89"
            height="61"
            :src="require('../assets/bn-w@2x.png')"
            @click="goToWelcome"
          >
          <main-nav-bar :class="{ 'nav-bar-home': isHomeRoute }" />
          <div class="md-layout md-alignment-center-right logout-button">
            <md-button @click="loginUser">
              Login & Watch Experience
            </md-button>
          </div>
        </div>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <div class="md-layout close-icon">
          <md-button
            class="md-icon-button"
            @click="menuVisible = !menuVisible"
          >
            <md-icon>close</md-icon>
          </md-button>
        </div>
        <secondary-nav-bar />
        <div class="md-layout md-alignment-center-center">
          <md-button @click="loginUser">
            Login & Watch Experience
          </md-button>
        </div>
      </md-app-drawer>

      <md-app-content>
        <router-view />
        <Footer />
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import MainNavBar from "@/components/NavBar/MainNavBar"
import SecondaryNavBar from "@/components/NavBar/SecondaryNavBar"
import Footer from "@/components/Footer"
export default {
  name: "App",
  components: {
    MainNavBar,
    SecondaryNavBar,
    Footer
  },
  data () {
    return {
      menuVisible: false,
      windowWidth: window.innerWidth,
      isHomeRoute: false,
      homeRoute: 'Home'
    }
  },
  computed: {
    hideMenu() {
      return this.windowWidth < 720
    }
  },
  watch: {
    '$route' (to, from) {
      console.log(window.scrollY)
      window.scrollTo(0, 0)
      this.isHome(to.name)
    }
  },
  async mounted() {
    window.scrollTo(0, 0)
    this.isHome(this.$route.name) 
    await this.$nextTick()
    window.addEventListener('resize', this.onResize)
    // window.addEventListener('contextmenu', event => event.preventDefault())
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize)
  },
  methods: {  
    onResize(value) {
      this.windowWidth = window.innerWidth
    },
    isHome(name) {
      this.isHomeRoute = name === this.homeRoute 
    },
    loginUser() {
      this.$router.push('/login')
    },
    goToWelcome() {
      this.$router.push('/welcome')
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Ubuntu;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.md-app {
  height: 100vh;
  &.md-fixed {
    overflow-x: hidden;
  }
}

.menu-items {
  display: flex;
  max-height: 71px;
  img {
    margin: 5px 0px 5px 21px;
  }
}

.menu-position {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.home-background {
  .md-tabs-navigation, .md-nav-color {
    background-color: $color-black !important;
    opacity: 0.9;
    &.md-theme-default {
      background-color: $color-black !important;
      opacity: 0.9;
      color: $color-white !important;
      .md-tabs-indicator {
        background-color: initial !important;
      }
    }
    .md-button {
      color: $color-white !important;
      &.md-active {
        color: $color-primary !important;
      }
    }
    .md-icon-button {
      .md-icon {
        color: $color-white !important;
      }
    }
  }
}

.md-app-content {
  height: 90vh;
  padding: 0 !important;
}
.logout-button {
  position: absolute;
  right: 20px;
  top: 10px;
}
</style>
